import css from 'styled-jsx/css';

const staticStyles = css.global`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/vars';
  @import 'src/common/styling/_mixins-scss/rem';
  .ChallengePageWrapper {
    width: 100%;
    background: white;
    padding: 32px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin-bottom: 20px;
  }

  .RefundableFee--wallet {
    color: #0aa1e2;
    font-feature-settings: 'liga' off, 'clig' off;
    font-size: 22px;
    font-style: normal;
    font-weight: 500;
    line-height: 160%;
  }

  .ChallengePage__ChallengeConditions {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .ChallengeAccountsItemWrapper {
    margin-bottom: 2px;
    box-shadow: 0px 1px 6px 1px rgba(0, 0, 0, 0.06);
  }

  .ChallengePage__Chart {
    padding: 32px;
    background: white;
  }

  .ChallengePage__Description {
    font-size: 17px;
    font-weight: 400;
  }
  .ChallengePageChart__Under {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;

    @include respond-to(md) {
      flex-direction: column;
    }
  }

  .ChallengePageChart__Item {
    padding: 12px 24px;
    border-radius: 4px;
    box-shadow: 0px 1px 6px 1px rgba(0, 0, 0, 0.06);
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 24px;
    span {
      color: rgba(0, 0, 0, 0.75);
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 140%;
    }

    @include respond-to(md) {
      width: 100%;
    }
  }

  .ChallengePageChart__Value {
    color: rgba(0, 0, 0, 0.75);
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 140%;
    display: flex;
    gap: 10px;
    justify-content: center;
    align-items: center;
  }
  .ChallengePageWrapper table tr td {
    height: 44px;
    text-align: center;
    border: 1px solid #eeeeee !important;
    border-collapse: collapse !important;
  }

  .ChallengePageWrapper .ChallengePage__Table tr:first-child {
    color: rgba(0, 0, 0, 0.75);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
  }

  .ChallengePageWrapper .ChallengePage__Table tr:nth-child(2) {
    color: #000;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 140%;
  }

  .ChallengePageWrapper .ChallengePage__Table tr td {
    height: 44px;
    text-align: center;
    border: 1px solid #eeeeee !important;
    border-collapse: collapse !important;
  }

  .ChallengePageWrapper .ChallengePage__Table th {
    border: 1px solid black;
    border-collapse: collapse;
  }

  .ChallengePageWrapper .ChallengePage__Table {
    border: 1px solid black;
    border-collapse: collapse;
  }
  .ChallengePageWrapper .ChallengePage__Table td {
    border: 1px solid black;
    border-collapse: collapse;
  }

  .ChallengePageWrapper__RefundableFee {
    display: flex;
    align-items: center;
    gap: 12px;
    @media only screen and (min-width: 1200px) {
      grid-column: 1/1;
      grid-row: 1/1;
    }
  }

  .ChallengePageWrapper__RefundableFee > span {
    color: #000;
    font-feature-settings: 'liga' off, 'clig' off;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 160%;
  }

  .ChallengePageWrapper__RefundableFee > div {
    color: #0aa1e2;
    font-feature-settings: 'liga' off, 'clig' off;
    font-size: 22px;
    font-style: normal;
    font-weight: 500;
    line-height: 160%;
  }
`;

export { staticStyles };
